import React from 'react';
import {CircularProgress} from "@material-ui/core";

class Spinner extends React.Component{
    render(){
        const {size} = this.props;
        return(
            <CircularProgress size={size || 16} />
        );
    }
}

export default Spinner;
